interface BankInfoSimilarCellDelegate
{
    similarCellDidSelectMovement(cell:BankInfoSimilarCell, movement:BankMovement): void;
    similarCellDidApply(cell:BankInfoSimilarCell, entry:BankMovement, movements:BankMovement[]): void;
}

// Uncategorized movements like the selected one: the first four, and the button that gives all of
// them the movement's analytic account and tags (disabled until the movement has an account)
class BankInfoSimilarCell extends UITableViewCell
{
    static visibleRows = 4;

    delegate:BankInfoSimilarCellDelegate = null;

    private rowsView:MUIView = null;
    private applyButton:MUIButton = null;

    private _entry:BankMovement = null;
    private _movements:BankMovement[] = [];
    private rows:MUIView[] = [];

    awakeFromHTML(){
        this.rowsView = MUIOutlet(this, "rows-view", "MUIView");

        this.applyButton = MUIOutlet(this, "apply-btn", "MUIButton");
        this.applyButton.setAction(this, function(this:BankInfoSimilarCell){
            if (this.delegate == null || this._entry == null) return;
            if (BankMovementState.isCategorized(this._entry) == false) return;
            this.delegate.similarCellDidApply(this, this._entry, this._movements);
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    setItem(entry:BankMovement, movements:BankMovement[]){
        this._entry = entry;
        this._movements = movements;

        for (let row of this.rows) row.removeFromSuperview();
        this.rows = [];

        let cf = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter;

        let count = Math.min(movements.length, BankInfoSimilarCell.visibleRows);
        for (let index = 0; index < count; index++){
            let mv = movements[index];

            let row = new MUIView();
            row.init();
            row.layer.style.position = "relative";
            MUICoreLayerAddStyle(row.layer, "info-similar-row");

            let texts = [
                { text: mv.date != null ? mv.date.getDate() + " " + BankEntryCell.shortMonth(mv.date) : "", style: "info-similar-date" },
                { text: mv.concept, style: "info-similar-concept" },
                { text: BankMovementState.signedAmountString(mv.amount), style: "info-similar-amount" }
            ];
            for (let item of texts) {
                let label = new MUILabel();
                label.init();
                label.layer.style.position = "relative";
                MUICoreLayerAddStyle(label.layer, "label");
                MUICoreLayerAddStyle(label.layer, item.style);
                label.text = item.text;
                row.addSubview(label);
            }

            row.layer.addEventListener("click", () => {
                if (this.delegate != null) this.delegate.similarCellDidSelectMovement(this, mv);
            });

            this.rowsView.addSubview(row);
            this.rows.push(row);
        }

        let categorized = BankMovementState.isCategorized(entry);
        let accountName = BankMovementState.analyticAccountTitle(entry);
        this.applyButton.title = categorized
            ? MIOLocalizeString("APPLY_ACCOUNT_TO_SIMILAR", "Apply «%s» to %d similar").replace("%s", accountName).replace("%d", String(movements.length))
            : MIOLocalizeString("ASSIGN_AN_ANALYTIC_ACCOUNT_FIRST", "Assign an analytic account first");
        if (categorized) MUICoreLayerRemoveStyle(this.applyButton.layer, "disabled");
        else MUICoreLayerAddStyle(this.applyButton.layer, "disabled");
    }
}
